<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Fiscale eenheid
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse show" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Een moedermaatschappij en haar dochtermaatschappijen kunnen een fiscale eenheid vormen. Bij een
                    fiscale eenheid doet je 1 aangifte voor meerdere bv's tegelijk. De resultaten van
                    dochtermaatschappijen worden toegerekend aan de moedermaatschappij. Voor het vormen van een fiscale
                    eenheid heb je vooraf toestemming van ons nodig, in de vorm van een beschikking.
                </p>
                <br/>
                <p>
                    Vermeld hier de moedermaatschappij en de in het boekjaar tot de fiscale eenheid behorende
                    dochtervennootschappen.
                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Aangifte doen voor een fiscale eenheid
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Bij een fiscale eenheid worden de resultaten van de dochtermaatschappij toegerekend aan de
                    moedermaatschappij. De dochtermaatschappij houdt niet op te bestaan (ook niet fiscaal), maar is niet
                    meer zelfstandig belastingplichtig. De belasting wordt geheven alsof er 1 belastingplichtige is.</p>
                <p>De voorwaarden die in principe gelden om als fiscale eenheid voor de vennootschapsbelasting te worden
                    beschouwd zijn genoemd in:</p>
                <ul>
                    <li>artikel 15 Vpb.</li>
                    <li>het Besluit fiscale eenheid 2003.</li>
                </ul>
                <p>De belangrijkste voorwaarde is dat de moedermaatschappij ten minste 95% van de aandelen in de
                    dochtermaatschappij moet bezitten. Verder moeten de moeder- en de dochtermaatschappij:</p>
                <ul>
                    <li>dezelfde boekjaren hanteren.</li>
                    <li>dezelfde fiscale regels voor hun winstbepalingen hanteren.</li>
                    <li>feitelijk gevestigd zijn in Nederland.</li>
                </ul>
                <p>Ook als de fiscale eenheid in de loop van het boekjaar is beëindigd, doe je aangifte voor een fiscale
                    eenheid. Als een dochtermaatschappij in de loop van het boekjaar deel is gaan uitmaken van de
                    fiscale eenheid, of in de loop van het boekjaar is ontvoegd, is zij gedurende een deel van het
                    boekjaar zelfstandig belastingplichtig. Voor het andere gedeelte maakt zij deel uit van de fiscale
                    eenheid.</p>
                <b>Binnenlandse vaste inrichting van een buitenlandse rechtspersoon</b>
                <p>Onder bepaalde voorwaarden kan ook een vaste inrichting van een buitenlandse moeder- of
                    dochtermaatschappij deel uitmaken van een fiscale eenheid. Vormt de binnenlandse moedermaatschappij
                    een fiscale eenheid met een vaste inrichting van een buitenlandse dochter, dan doe je alleen
                    aangifte over de resultaten van de binnenlandse moedermaatschappij en die van de vaste inrichting.
                    De buitenlandse dochter moet zelf aangifte doen over haar eventuele resultaten die niet uit de vaste
                    inrichting afkomstig zijn.</p>
            </div>
        </div>
    </div>
</div>
